import {useEffect} from 'react'

import {dispatch, useSelector} from '../../store.js'
import {TRANSFER_DETAIL_PAGE} from '../../common/constants/Pages.js'
import {setCurrentPage} from '../../redux/actions/ui/index.js'
import {
  setupTransferDetailForm,
  removeTransferDetailForm,
  getCurrentDetailTransfer,
  transferDetailTransferIDSelector,
} from './transferDetailFunctions.js'

export default function TransferDetailLocationListener() {
  const transferID = useSelector(transferDetailTransferIDSelector)

  useEffect(() => {
    if (!transferID) {
      return
    }

    setupTransferDetailForm()

    dispatch(setCurrentPage(TRANSFER_DETAIL_PAGE))

    getCurrentDetailTransfer()

    return () => removeTransferDetailForm()
  }, [transferID])

  return null
}
